import { Group, GroupProps, MantineSize, Text } from "@mantine/core"
import { ReactNode } from "react"

import { HelpHover } from "../HelpHover/HelpHover"
import { Missing } from "../Missing/Missing"

export type InformationItemProps = {
  title?: string
  value: string | ReactNode
  direction?: "row" | "column"
  icon?: ReactNode
  helpHover?: ReactNode | string
  size?: MantineSize
} & GroupProps

export const InformationItem = ({
  title,
  value,
  direction = "row",
  icon,
  helpHover,
  size = "xs",
  ...groupProps
}: InformationItemProps) => {
  return (
    <Group
      gap="var(--mantine-molecule-padding-x)"
      style={{ flexDirection: direction }}
      justify="space-between"
      flex={1}
      wrap="nowrap"
      {...groupProps}
    >
      {title && (
        <Group wrap="nowrap">
          <Text size={size} style={{ whiteSpace: "nowrap" }}>
            {title}
            {" : "}
          </Text>
        </Group>
      )}
      <Group wrap="nowrap">
        {typeof value === "string" ? (
          <Text fw={500}>{value}</Text>
        ) : value ? (
          value
        ) : (
          <Missing />
        )}
        {helpHover && (
          <HelpHover icon={icon}>
            <Text size="xs">{helpHover}</Text>
          </HelpHover>
        )}
      </Group>
    </Group>
  )
}
